
<template>
  <transition name="router-anim">
    <div class="kits">
      <table class="styled-table">
        <thead>
          <tr>
            <th class="title-data">Questions</th>
            <th class="title-data">Yes</th>
            <th class="title-data">No</th>
            <th class="title-data">Skipped</th>
            <th class="title-data">Action</th>
          </tr>
        </thead>
          <tbody>
            <tr v-for="(item,index) in analyticsUserCount" :key="index">
              <td>{{item.question}}</td>
              <td>{{item.checked}}  <img
                    @click="change('yes',item.type,item.checked,item.total)"
                      class="onhold-btn-img"
                      src="../../../images/dashboard/eye.svg"
                      title="View Records"
                      alt="#"
                  />
              </td>
              <td>{{item.unchecked}}
                  <img
                      @click="change('no',item.type,item.unchecked,item.total)"
                      class="onhold-btn-img"
                      src="../../../images/dashboard/eye.svg"
                      title="View Records"
                      alt="#"
                  />
              </td>
              <td>{{item.null}}
                  <img
                      @click="change('skipped',item.type,item.null,item.total)"
                      class="onhold-btn-img"
                      title="View Records"
                      src="../../../images/dashboard/eye.svg"
                      alt="#"
                  />
            </td>
            <td>
                  <span
                    class="download-link"
                    target="_blank"
                    title="Download"
                  >
                    <span class="download"    @click="AnalyticsInfoCsv({type:item.type,data_type:true})">
                      <img src="../../../images/dashboard/download.svg" alt="#" />
                    </span>
                  </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </transition>
</template>
<script>
import { mapActions,mapGetters} from "vuex";
export default {
  name: "AnalyticsCount",
    data() {
        return {
          analyticsUserCount: [],
          analyticsUsers: [],
          date_from: null,
          date_to: null,
        };
    },
     computed: {
    ...mapGetters(["getAnalyticsCounts","getAnalyticsAll"])
  },
  watch: {
    getAnalyticsCounts(obj) {
      this.analyticsUserCount = obj.data;
    },
    getAnalyticsAll(obj) {
      this.analyticsUsers = obj.data;
    }
  },
  mounted() {
    this.analyticsUserCount = this.$store.getters.getAnalyticsCounts.data;
    if(this.$store.getters.getAnalyticsAll) {
      this.analyticsUsers = this.$store.getters.getAnalyticsAll;
    }
  },
  methods:{
    ...mapActions([
      "getAnalyticsInfoList",
      "setAnalyticsHead",
      "setAdminPginationPage",
      "setAnalyticsFilter",
      "setSerachString",
      "setStatusFilter",
      "setDateFromAnalytics",
      "setDateToAnalytics",
      "getAnalyticsInfoCsv"
    ]),
    change(item,type,count,total){
      this.setSerachString("");
      this.setStatusFilter([]);
      this.setDateFromAnalytics(null);
      this.setDateToAnalytics(null);
      this.setAnalyticsHead({status:3,type,show:true,item,count,total});
      const data ={item,type};
      this.setAdminPginationPage(item).then(() => {
        this.setAnalyticsFilter(data);
        this.setAdminPginationPage(null).then(() => {
          this.getAnalyticsInfoList(data).then(res => {
            this.$emit("shows", { show: true});
          });
        });
      });
    },
    AnalyticsInfoCsv(data) {
      this.getAnalyticsInfoCsv(data).then(async response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `${data.type}_Count.csv`
        );
        link.click();
      });
    },
  }
}
</script>

<style scoped lang="scss">
@import "../../../styles/colors";
.kits {
  margin: 20px 0 0 0;
}
table {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
  background-color: $white;
}

td,
th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
}
img{
  height: 1em;
}
:hover .onhold-btn-img {
  cursor: pointer;
}
.download-link {
  display: flex;
  position: relative;
  justify-content: flex-start;
  align-items: center;
  margin: 0 20px 0 0;
  cursor: pointer;
}
.download-link-btn {
  text-align: left;
  background-color: transparent;
  border: none;
  outline: none;
}
.download-link.span {
  max-width: 135px;
}
.download {
  width: 25px;
  height: 25px;
  background-color: #03409a;
  border-radius: 100%;
  display: flex;
  cursor: pointer;
  align-items: center;
  justify-content: center;
}
.download img {
  max-width: 12px;
  height: auto;
  cursor: pointer;
}
.action-icons {
  display: flex;
  align-items: center; // Vertically align items
  gap: 5px; // Add spacing between eye icon and download button
}
.styled-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
  font-size: 0.9em;
  text-align: left;
}
.styled-table thead tr {
  background-color: #005eb8;
  color: #ffffff;
  text-align: left;
  height: 37px;
}
.styled-table th, .styled-table td {
  padding: 12px 15px;
  border-bottom: 1px solid #dddddd;
  font-size: 14px;
  font-family: TTNormsLight,sans-serif;
}
.styled-table tbody tr {
  border-bottom: 1px solid #dddddd;
}
.styled-table tbody tr:nth-of-type(even) {
  background-color: #f3f3f3;
}
.styled-table tbody tr:last-of-type {
  border-bottom: 2px solid #005eb8;
}
.styled-table tbody tr.active-row {
  font-weight: bold;
  color: #005eb8;
}
.title-data {
  font-size: 14px;
  font-family: TTNormsMedium, sans-serif;
}
.sort-data{
  padding-left: 10px;
}
.sort-data .down {
  transform: rotate(180deg);
}
.styled-table tbody tr .changed-name{
  width:150px !important;
}
.entity-label {
  font-weight: bold; /* Highlight the entity label */
  margin-right: 8px; /* Add space after "Indoor sample" */
  width: 20px;
}
</style>
